export default __webpack_public_path__ + "static/media/bootom-banner.2a0129fe.webp";